import React from 'react';

const StudioTopNav = () => {
  return (
    <header className="studio-topbar inner-glow-top" style={{ justifyContent: 'center' }}>
    </header>
  );
};

export default StudioTopNav;
